import { ConfigForm as form, marshal } from './ConfigForm'

const provider = {
  label: 'Readflow',
  form,
  marshal 
}

export default provider
